import { defineStore } from "pinia";
import apiDriveListeCourse from "@/services/http/api-drive/client/listeDeCourse";
import { useMagasinStore } from "./magasin";

export const StatusTypes = {
  ADD_TO_LIST_REQUEST: 'ADD_TO_LIST_REQUEST',
  ADD_TO_LIST_SUCCESS: 'ADD_TO_LIST_SUCCESS',
  ADD_TO_LIST_ERROR: 'ADD_TO_LIST_ERROR'
}

const mapArticle = (article) => {
  return {
    id: article.id,
    pft: article.pft,
    quantite: 1,
    indexPoids: article.indexPoids ? article.indexPoids : 0
  }
}

export const useListeDeCoursesStore = defineStore({
  id: 'liste-de-courses',
  state: () => {
    return {
      article: null,
      status: null,
      error: null
    }
  },
  actions: {
    setArticle(article) {
      this.article = article;
    },
    reset() {
      this.article = null;
      this.status = null;
      this.error = null;
    },
    addToListRequest() {
      this.status = StatusTypes.ADD_TO_LIST_REQUEST;
    },
    addToListSuccess() {
      this.status = StatusTypes.ADD_TO_LIST_SUCCESS;
    },
    addToListError(error) {
      this.error = error;
      this.status = StatusTypes.ADD_TO_LIST_ERROR;
    },
    async addArticleToList(listeId) {
      const magasinStore = useMagasinStore();

      this.addToListRequest();
      try {
        await this.$apiDrive.use(apiDriveListeCourse).addItem(listeId, magasinStore.id, mapArticle(this.article));
        this.addToListSuccess();
      } catch (err) {
        this.addToListError(this.$apiDrive.getErrorData(err));
      }
    },
    async addArticleToNewList(titre) {
      const magasinStore = useMagasinStore();

      this.addToListRequest();
      try {
        await this.$apiDrive.use(apiDriveListeCourse).create(
          magasinStore.id,
          {
            titre,
            items: [mapArticle(this.article)]
          }
        );
        this.addToListSuccess();
      } catch (err) {
        this.addToListError(this.$apiDrive.getErrorData(err));

      }
    }
  },
  getters: {
  }
})
